import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Termini di Servizio</h1>
          <p className="text-gray-700 mb-8">Termini applicabili ai servizi offerti da AffittoOnline.it, conformi alla normativa italiana e alle disposizioni del Codice del Consumo ove applicabili.</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Accettazione dei termini</h2>
            <p className="text-gray-700">Utilizzando il sito e i servizi, l’utente accetta i presenti termini e le politiche applicabili.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Descrizione del servizio</h2>
            <p className="text-gray-700">Il servizio comprende consulenza preliminare, individuazione della tipologia di contratto e redazione personalizzata del documento, erogati in videoconferenza. Possono essere richiesti servizi aggiuntivi come firma digitale e registrazione all’Agenzia delle Entrate.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Prezzi e pagamenti</h2>
            <p className="text-gray-700">Il servizio di redazione prevede pagamento solo se l’utente è soddisfatto del risultato. I servizi aggiuntivi possono avere tariffe separate. I prezzi sono indicati sul sito o comunicati prima dell’erogazione.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Obblighi dell’utente</h2>
            <p className="text-gray-700">L’utente garantisce che le informazioni fornite sono veritiere e aggiornate, e si impegna a utilizzare i servizi nel rispetto delle leggi vigenti.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Responsabilità</h2>
            <p className="text-gray-700">Nei limiti di legge, il servizio è fornito con diligenza professionale. Non rispondiamo per usi impropri dei documenti o per informazioni inesatte fornite dall’utente. Restano fermi i diritti inderogabili del consumatore.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Diritto di recesso</h2>
            <p className="text-gray-700">Per i servizi di redazione personalizzata, il diritto di recesso è escluso ai sensi dell’art. 59, lett. c) del Codice del Consumo. L’utente può annullare gratuitamente la prenotazione prima dell’avvio della prestazione. Per servizi aggiuntivi già erogati o iniziati su richiesta espressa dell’utente, il recesso non è possibile ai sensi dell’art. 59, lett. a).</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Proprietà intellettuale</h2>
            <p className="text-gray-700">I contenuti del sito e i materiali forniti sono di proprietà di AffittoOnline.it. È vietata la riproduzione o distribuzione non autorizzata.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Legge applicabile, foro e ODR</h2>
            <p className="text-gray-700">I presenti termini sono regolati dalla legge italiana. Per le controversie con consumatori è competente il foro del luogo di residenza o domicilio del consumatore, ove previsto. Piattaforma ODR UE: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer" className="text-blue-600">https://ec.europa.eu/consumers/odr/</a>.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">Privacy e contatti</h2>
            <p className="text-gray-700">Informazioni sul trattamento dei dati sono disponibili nella <a href="/privacy" className="text-blue-600">Informativa Privacy</a>. Contatti: <a href="mailto:info@contrattionline.it" className="text-blue-600">info@contrattionline.it</a> • Tel: <a href="tel:+393470088959" className="text-blue-600">+39 3470088959</a>.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}